<template>
  <sea-page
    title="Lista lavoratori"
    header="Lista lavoratori"
    showCompanyHeader
    :back="currentCompany !== null"
  >
    <sea-page-content
      ref="list"
      :fetchList="fetchList"
      :resetList="resetList"
      :deleteItems="deleteSelected"
      toolbar
      pulsanteAggiorna
      pulsanteVaiAllaLista
      @pulsanteVaiAllaListaClick="createItem"
      max
      pulsante-elimina
      :pulsanteEliminaDisabled="!currentRow"
    >
      <template v-slot:toolbar>
        <table-toolbar-button
          icon="mdi-account-convert"
          label="Reset account"
          @click="openResetDialog"
          :disabled="!currentRow || !currentRow.activable"
        ></table-toolbar-button>
        <table-toolbar-button
          icon="mdi-email-send"
          label="Invia e-mail credenziali primo accesso"
          @click="openSendDialog"
          :disabled="!currentRow || currentRow.activable"
        ></table-toolbar-button>
        <table-toolbar-button
          icon="mdi-lock-reset"
          label="Invia e-mail di reset password"
          @click="resetPasswordInit"
          :disabled="!currentRow || !currentRow.activated || (currentRow.activated && !currentRow.activable)"
        ></table-toolbar-button>
        <!-- <table-toolbar-button
          icon="mdi-lock-check"
          label="Attiva account default"
          @click="openActivateDialog"
          :disabled="!currentRow || currentRow.activable"
        ></table-toolbar-button>
        <table-toolbar-button
          icon="mdi-lock-minus"
          label="Reset password default"
          @click="resetPwdManually"
          :disabled="!currentRow || !currentRow.activated"
        ></table-toolbar-button> -->
        <table-toolbar-button
          icon="mdi-account-reactivate"
          label="Abilita/Disabilita utenza"
          @click="activationUser"
          :disabled="!currentRow || !currentRow.activable"
        ></table-toolbar-button>
      </template>
      <template v-slot:table="{ attrs, height }">
        <v-data-table
          v-model="attrs.selected"
          v-bind="attrs"
          :height="height"
          :headers="headers"
          :items="items"
          sort-by="email"
          dense
          show-select
          item-key="id"
          single-select
          @item-selected="itemSelected"
          @click:row="rowClick"
        >
          <template v-slot:item.activated="{ item }">
            <check-icon :checked="item.activated"></check-icon>
          </template>
          <template v-slot:item.activable="{ item }">
            <check-icon :checked="item.activable"></check-icon>
          </template>

          <template v-slot:item.privacyDate="{ item }">
           <span v-if="item.privacyDate">Presa visione il {{ item.privacyDate | dateFormat }}</span>
          </template>
        </v-data-table>
      </template>
      <sea-dialog
        ref="activateDialog"
        title="Attivazione utente"
        confirmLabel="Attiva"
        :confirmDisabled="$v.datiUtente.$invalid"
        @confirmed="activateManually"
      >
        <p>*La password di attivazione manuale è 'winpeople'</p>
        <v-text-field
          label="Username"
          placeholder="Username"
          type="text"
          v-model="datiUtente.login"
          required
          :error-messages="errors('login')"
          @input="$v.datiUtente.login.$touch()"
          @blur="$v.datiUtente.login.$touch()"
        ></v-text-field>
        <v-text-field
          label="Email"
          placeholder="Email"
          type="email"
          v-model="datiUtente.email"
          :error-messages="errors('email')"
          @input="$v.datiUtente.email.$touch()"
          @blur="$v.datiUtente.email.$touch()"
        ></v-text-field>
      </sea-dialog>
      <sea-dialog
        ref="resetDialog"
        title="Reset account utente"
        confirmLabel="Reset"
        :confirmDisabled="$v.datiReset.$invalid"
        @confirmed="resetAccount"
      >
        <v-text-field
          label="Email"
          placeholder="Email"
          type="email"
          v-model="datiReset.email"
          :error-messages="resErrors()"
          @input="$v.datiReset.email.$touch()"
          @blur="$v.datiReset.email.$touch()"
        ></v-text-field>
      </sea-dialog>
      <sea-dialog
        ref="sendDialog"
        title="Invio email di attivazione"
        confirmLabel="Invia"
        :confirmDisabled="$v.datiInvio.$invalid"
        @confirmed="sendActivationEmail"
      >
        <v-text-field
          label="Email"
          placeholder="Email"
          type="email"
          v-model="datiInvio.email"
          :error-messages="invErrors()"
          @input="$v.datiInvio.email.$touch()"
          @blur="$v.datiInvio.email.$touch()"
        ></v-text-field>
      </sea-dialog>
    </sea-page-content>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import mixin from "@/mixin";
//sendActivationEmail
const headers = [
  {
    text: "Cognome",
    value: "lastName",
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "Nome",
    value: "firstName",
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "Email",
    value: "email",
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "Attivo",
    value: "activated",
    filterable: false,
    sortable: false,
    align: "center",
  },
  {
    text: "Credenziali utente",
    value: "activable",
    filterable: false,
    sortable: false,
    align: "center",
  },
  {
    text: "Account",
    value: "login",
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "Privacy",
    value: "privacyDate",
    class: "heading",
    cellClass: "text-little-2 hand",
  },
];

export default {
  mixins: [mixin, validationMixin],
  validations: {
    datiUtente: {
      login: {
        required,
      },
      email: {
        email,
      },
    },
    datiReset: {
      email: {
        email,
        required,
      },
    },
    datiInvio: {
      email: {
        email,
        required,
      },
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.codiceAzienda) {
        vm.setWCurrentCompany(to.query.codiceAzienda);
      }
      if (to.query.idAzienda) {
        vm.setCurrentCompany(to.query.idAzienda);
      }
    });
  },
  data() {
    return {
      headers,
      selected: [],
      currentRow: null,
      datiUtente: {
        login: "",
        email: "",
      },
      datiReset: {
        email: "",
      },
      datiInvio: {
        email: "",
      },
    };
  },
  methods: {
    ...mapActions({
      fetchList: "users/fetchEmployees",
      delete: "users/deleteCompanyEmployee",
      isPrivacyOk: "docsAzi/isPrivacyOk",
      activateUserManually: "account/activateUserManually",
      resetUser: "account/resetUser",
      setCurrentCompany: "users/setCurrentCompany",
      _activationUser: "users/activationUser",
      _sendActivationEmail: "account/sendActivationEmail",
      _resetPasswordInit: "account/resetPasswordMail",
      resetPasswordManually: "account/resetPasswordManually",
      setWCurrentCompany: "widget/setCurrentCompany",
    }),
    ...mapMutations({
      resetList: "users/RESET_EMPLOYEES",
    }),
    openActivateDialog() {
      this.$refs.activateDialog.open();
    },
    openResetDialog() {
      if (this.currentRow) {
        if (this.currentRow.email) {
          this.datiReset.email = this.currentRow.email;
        }
        this.$refs.resetDialog.open();
      }
    },
    openSendDialog() {
      console.log(this.currentRow);
      if (this.currentRow) {
        if (this.currentRow.email) {
          this.datiInvio.email = this.currentRow.email;
        }
        this.$refs.sendDialog.open();
      }
    },
    rowClick: function (item, row) {
      row.select(!row.isSelected);
    },
    activateManually() {
      this.$v.$touch();
      if (!this.$v.datiUtente.$invalid) {
        this.activateUserManually({
          id: this.currentRow.id,
          login: this.datiUtente.login,
          email: this.datiUtente.email,
        }).then(() => {
          this.fetchList();
        });
      }
    },
    resetAccount() {
      this.$v.$touch();
      if (!this.$v.datiReset.$invalid) {
        this.resetUser({
          id: this.currentRow.id,
          email: this.datiReset.email,
        }).then(() => {
          this.fetchList();
        });
      }
    },
    sendActivationEmail() {
      this.$v.$touch();
      if (!this.$v.datiInvio.$invalid) {
        this._sendActivationEmail({
          id: this.currentRow.id,
          email: this.datiInvio.email,
        }).then(() => {
          this.fetchList();
        });
      }
    },
    resetPwdManually() {
      this.resetPasswordManually(this.currentRow.id);
    },
    errors(fieldName) {
      const vals = [];
      if (!this.$v.datiUtente[fieldName].$dirty) return vals;
      if (fieldName === "login") {
        !this.$v.datiUtente.login.required && vals.push(this.locales.required);
      } else if (fieldName === "email") {
        !this.$v.datiUtente.email.email && vals.push(this.locales.email);
      } else if (fieldName === "email") {
        !this.$v.datiUtente.login.required && vals.push(this.locales.required);
        !this.$v.datiUtente.email.email && vals.push(this.locales.email);
      }
      return vals;
    },
    resErrors() {
      const vals = [];
      if (!this.$v.datiReset.email.$dirty) return vals;
      !this.$v.datiReset.email.required && vals.push(this.locales.required);
      !this.$v.datiReset.email.email && vals.push(this.locales.email);
      return vals;
    },
    invErrors() {
      const vals = [];
      if (!this.$v.datiInvio.email.$dirty) return vals;
      !this.$v.datiInvio.email.required && vals.push(this.locales.required);
      !this.$v.datiInvio.email.email && vals.push(this.locales.email);
      return vals;
    },
    async createItem() {
      this.$router.push({
        path: "/company/employees/import",
        query: {
          codiceAzienda: this.WcurrentCompany,
          idAzienda: this.currentCompany,
        },
      });
    },
    itemSelected(payload) {
      this.currentRow = payload.value ? payload.item : null;
    },
    activationUser() {
      if (this.currentRow) {
        this.currentRow.activated = !this.currentRow.activated;
        this._activationUser(this.currentRow);
      }
    },
    resetPasswordInit() {
      if (this.currentRow) {
        this._resetPasswordInit(this.currentRow.login);
      }
    },
    confirm() {
      this.$refs.list.openDeleteConfirm();
    },
    async deleteSelected() {
      await this.delete(this.currentRow.login);
      this.currentRow = null;
      await this.$refs.list.updateList();
    },
  },
  computed: {
    activated() {
      return this.currentRow && this.currentRow.activated;
    },
    ...mapGetters({
      items: "users/employees",
      currentCompany: "users/currentCompany",
      WcurrentCompany: "widget/currentCompany",
    }),
  },
};
</script>

<style>
</style>
